document.addEventListener('DOMContentLoaded', () => {
//フォロー
  followBtn = document.getElementById("js-followBtn") ?? null;
  if (followBtn){
    followBtn.addEventListener('click', () => {
      _toggleFollow(followBtn);
    });
  }
  
});

//サーバー通信
let connecting = false;
let messages = [];
const messageWrap = document.getElementById('js-error');
//フォロー
let followBtn = null;

/**
 * Ajax 通信失敗時に起動させるメソッド
 */
const _handleError = () => {
  //通信中フラグを false にする
  connecting = false;
  
  //エラーを追加
  messages.push('サーバーで処理に失敗しました。再度お試し頂くか、お問い合わせ下さい。');
};
/**
 * Ajax 中断時に起動させるメソッド
 */
const _handleAbort = () => {
  //通信中フラグを false にする
  connecting = false;
  
  //エラーを追加
  messages.push('通信が中断されました。再度お試し下さい。');
};
/**
 * Ajax タイムアウトに起動させるメソッド
 */
const _handleTimeout = () => {
  //通信中フラグを false にする
  connecting = false;
  
  //エラーを追加
  messages.push('通信タイムアウトしました。ネットワーク回線を確認の上、再度お試し下さい。');
};
//サーバーと通信する部分
const _serverConnect = (onSuccess, onFail,openMethod, openUrl, sendBody = null) => {
  //通信中だったら何もしない
  if (connecting) {
    return Promise.reject();
  }
  
  //送信中フラグを on にする
  connecting = true;
  
  //非同期処理開始
  return new Promise((resolve, reject) => {
    //xhr を用意
    const xhr = new XMLHttpRequest();
    
    //通信失敗時
    xhr.addEventListener('error', () => {
      reject();
      _handleError();
    })
    xhr.addEventListener('timeout', () => {
      reject();
      _handleAbort();
    })
    xhr.addEventListener('abort', () => {
      reject();
      _handleTimeout();
    })
    
    //通信成功時処理
    xhr.addEventListener('load', event => {
      //送信中フラグを解除
      connecting = false;
      //成功・失敗のどちらでも response を JSON としてパースする
      let data = null;
      try {
        data = JSON.parse(event.target.response);
      }
      catch (e){
        console.log(e);
        messages = ['エラーが発生しました。恐れ入りますが再度お試しください。'];
        reject();
        return;
      }
      //パースに失敗
      if (data === null) {
        messages = ['サーバー情報のパースに失敗しました'];
        reject();
        return;
      }
      //失敗判定
      if (event.target.status >= 400) {
        messages = data.messages;
        onFail(data)
        reject(data.messages);
        return;
      }
      
      //成功したら結果を描写
      onSuccess(data);
    });
    
    //通信を試みる
    xhr.open(openMethod, openUrl);
    xhr.setRequestHeader('X-CSRF-Token', csrf_token)
    xhr.send(sendBody);
  });
};
//成功
function _success() {
  //成功表示用のトーストを得る
  const toast = document.querySelector('.js-successToast');
  
  //トーストがあれば表示
  if (toast) {
    toast.style.display = '';
    toast.classList.add('isDsply');
    setTimeout(() => { toast.classList.remove('isDsply') }, 1500);
  }
}
//失敗
function _fail() {
  if (messageWrap) {
    messageWrap.innerText = '';
    for (const msg of messages) {
      messageWrap.innerText += msg+"\n";
    }
  }
}

//フォローをトグル
const _toggleFollow = (btn) => {
  messages = [];
  const authorId = btn.value ?? null;
  if (!authorId) {
    return;
  }
  _serverConnect((data) => {
      if (btn.classList.contains('mdFollow')) {
        btn.classList.remove('mdFollow');
        btn.textContent = '著者をフォロー';
      }
      else {
        btn.classList.add('mdFollow');
        btn.textContent = '著者フォロー中';
      }
      
      _success();
    },
    (data) => {
      _failFollow();
    },
    'get',
    toggleFollow_ep+'/'+authorId
  );
};